import React from 'react';
import PropTypes from 'prop-types';

// Label custom (from scratch) — remplace le Label de reactstrap.
// Reproduit les classes générées par reactstrap : `form-label` par défaut,
// `form-check-label` quand `check`, `visually-hidden` quand `hidden`.
const Label = ({ className, hidden, tag: Tag = 'label', check, for: forProp, htmlFor, children, ...attributes }) => {
  const classes = [
    hidden && 'visually-hidden',
    check ? 'form-check-label' : 'form-label',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Tag htmlFor={htmlFor || forProp} className={classes} {...attributes}>
      {children}
    </Tag>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  check: PropTypes.bool,
  htmlFor: PropTypes.string,
  for: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default Label;
